import { BillingEntityTypeEnum, BillingTransactionTypeEnum } from '@api/READ_ONLY/billing_api/Api';
import type { StaffPayoutType, StaffType } from './types';

// Explicit both ways: an unmapped value returns undefined, never a doctor or caregiver.
export const STAFF_TYPES: readonly StaffType[] = ['doctor', 'caregiver', 'provider'];

export const PAYOUT_TYPE_BY_STAFF_TYPE: Record<StaffType, StaffPayoutType> = {
  doctor: BillingTransactionTypeEnum.DoctorPayout,
  caregiver: BillingTransactionTypeEnum.CaregiverPayout,
  provider: BillingTransactionTypeEnum.ProviderPayout,
};

export const ENTITY_TYPE_BY_STAFF_TYPE: Record<StaffType, BillingEntityTypeEnum> = {
  doctor: BillingEntityTypeEnum.Doctor,
  caregiver: BillingEntityTypeEnum.Caregiver,
  provider: BillingEntityTypeEnum.Provider,
};

export const isStaffPayoutType = (type: BillingTransactionTypeEnum | undefined): type is StaffPayoutType =>
  type === BillingTransactionTypeEnum.DoctorPayout ||
  type === BillingTransactionTypeEnum.CaregiverPayout ||
  type === BillingTransactionTypeEnum.ProviderPayout;

export const staffTypeFromPayoutType = (type: BillingTransactionTypeEnum | undefined): StaffType | undefined =>
  STAFF_TYPES.find((staffType) => PAYOUT_TYPE_BY_STAFF_TYPE[staffType] === type);

export const staffTypeFromEntityType = (type: string | null | undefined): StaffType | undefined =>
  STAFF_TYPES.find((staffType) => ENTITY_TYPE_BY_STAFF_TYPE[staffType] === type);
